import { Paper, Stack, useTheme } from '@mui/material';
import { Helmet } from 'react-helmet-async';
import { ProfileRemindersContent } from 'src/sections/@dashboard/profile/components/ProfileRemindersContent';

export default function ProfileTabsRemindersPage() {
  const theme = useTheme();

  return (
    <>
      <Helmet>
        <title>Przypomnienia | Vetsi</title>
      </Helmet>

      <Paper
        sx={{
          borderRadius: 2,
          boxShadow: theme.customShadows.z8,
          height: 1,
        }}
      >
        <Stack sx={{ height: 1, minHeight: '560px' }}>
          <ProfileRemindersContent />
        </Stack>
      </Paper>
    </>
  );
}
